import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const ChronoIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" width="40" height="40" {...props}>
            <path
                d="M20.1585 9.83958C26.741 9.83958 32.0775 15.1761 32.0775 21.7586C32.0775 27.4105 28.1138 32.2439 22.6749 33.4113C22.6794 33.4093 22.7258 35.0337 22.7258 35.0337C29.0434 33.8189 33.6775 28.2678 33.6775 21.7586C33.6775 14.2924 27.6247 8.23958 20.1585 8.23958V9.83958Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.7095 21.7585C23.7095 23.4447 22.5344 24.8569 20.9585 25.2199V35.1587H19.3585V25.22C17.7823 24.8571 16.607 23.4449 16.607 21.7585C16.607 19.797 18.1969 18.2072 20.1583 18.2072C22.1197 18.2072 23.7095 19.797 23.7095 21.7585ZM22.1095 21.7585C22.1095 20.6807 21.236 19.8072 20.1583 19.8072C19.0805 19.8072 18.207 20.6807 18.207 21.7585C18.207 22.8364 19.0807 23.7105 20.1583 23.7105C21.2358 23.7105 22.1095 22.8364 22.1095 21.7585Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0414 0H15.2756C14.8337 0 14.4756 0.358172 14.4756 0.8C14.4756 1.24183 14.8337 1.6 15.2756 1.6H19.3587V4.01769C15.6947 4.18007 12.3194 5.45273 9.56084 7.50741L8.2392 5.83304L6.98331 6.82437L8.32166 8.51991C4.68727 11.7717 2.3999 16.498 2.3999 21.7585C2.3999 31.5662 10.3509 39.5177 20.1584 39.5177C29.9658 39.5177 37.9168 31.5662 37.9168 21.7585C37.9168 16.3953 35.5392 11.5874 31.7807 8.33116L33.1303 6.62133L31.8744 5.63001L30.5256 7.33876C27.8106 5.38331 24.521 4.17571 20.9587 4.01771V1.6H25.0414C25.4833 1.6 25.8414 1.24183 25.8414 0.8C25.8414 0.358172 25.4833 0 25.0414 0ZM20.1584 5.6C29.0823 5.6 36.3168 12.8345 36.3168 21.7585C36.3168 30.6826 29.0821 37.9177 20.1584 37.9177C11.2346 37.9177 3.9999 30.6826 3.9999 21.7585C3.9999 12.8345 11.2344 5.6 20.1584 5.6Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChronoIcon
